import axios from "axios";

// Public catalogue page API (JJWEBAPI api/CatalogueView). Nothing past `meta` works without a view
// token (vt), which the visitor gets by entering one of the link's mobile numbers.
const base = () => global.config.APIURL.BaseURL + "api/CatalogueView/";
const enc = encodeURIComponent;

export const catalogueShareApi = {
  meta: (t) => axios.get(base() + "Meta", { params: { t } }).then((r) => r.data),

  unlock: (token, mobile) =>
    axios.post(base() + "Unlock", { Token: token, Mobile: mobile }).then((r) => r.data),

  share: (vt) => axios.get(base() + "Share", { params: { vt } }).then((r) => r.data),

  catalogue: (vt, c) => axios.get(base() + "Catalogue", { params: { vt, c } }).then((r) => r.data),

  coverUrl: (vt, c, v) => `${base()}Cover?vt=${enc(vt)}&c=${c}&v=${v}`,
  pageUrl: (vt, c, v, p) => `${base()}Page?vt=${enc(vt)}&c=${c}&v=${v}&p=${p}`,
  downloadUrl: (vt, c) => `${base()}Download?vt=${enc(vt)}&c=${c}`,

  // How far a catalogue was read. text/plain so sendBeacon needs no CORS preflight.
  progress: (vt, c, maxPage, seconds) => {
    const body = JSON.stringify({ vt, c, maxPage, seconds });
    const url = base() + "Progress";
    try {
      if (navigator.sendBeacon && navigator.sendBeacon(url, new Blob([body], { type: "text/plain" }))) return;
    } catch {
      /* fall back */
    }
    fetch(url, { method: "POST", body, headers: { "Content-Type": "text/plain" }, keepalive: true }).catch(() => {});
  },
};

// The API answers refusals as { Code, Message }.
export const errorCode = (err) => err?.response?.data?.Code || (err?.response ? `HTTP_${err.response.status}` : "NETWORK");
